import React, { useCallback, useState } from 'react';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

import SelectableModelHistoryList from './SelectableModelHistoryList';

import useListModelVersions from '../hooks/useListModelVersions';

const AdminModelHistorySection = ({
  error, versions, selectedVersions, setSelectedVersions
}) => (
  <div className="flex flex-col h-64">
    <div className="w-filter-modal flex flex-col overflow-scroll">
      <SelectableModelHistoryList
        values={versions}
        selectedValues={selectedVersions}
        setSelectedValues={setSelectedVersions}
      />
    </div>
    {
      error && (
        <div className="p-2 h-full flex flex-col-reverse justify-start self-center">
          <Label color="error" size="sm">
            Error while deleting the selected version(s). Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
          </Label>
        </div>
      )
    }
  </div>
)

export const AdminPipelineHistoryModal = ({
  row,
  // error = null,
  onVersionsSelected = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const [selectedVersions, setSelectedVersions] = useState([]);
  const id = row?.original?.id;
  const name = row?.original?.name;
  const workspaceId = row?.original?.workspace?.workspace_id;
  const { data, isLoading, error } = useListModelVersions(name, workspaceId);

  const onConfirm = useCallback(() => {
    onVersionsSelected(selectedVersions, id, workspaceId);
  }, [onVersionsSelected, id, selectedVersions, workspaceId])

  const disableConfirm = !selectedVersions?.length;
  return (
    <ConfirmationDialog
      title="Manage Versions"
      confirmButtonText="Delete Selected"
      confirmButtonType="danger"
      modalAnimationKey="manage-model-versions-modal"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      onConfirm={onConfirm}
      disableConfirmationButton={disableConfirm}
    >
      <AdminModelHistorySection
        error={error}
        versions={data ?? []}
        selectedVersions={selectedVersions}
        setSelectedVersions={setSelectedVersions}
      />
    </ConfirmationDialog>
  )
};

export default AdminPipelineHistoryModal;
